// @flow

import React from 'react'
import Link from 'gatsby-link'
import { compose } from 'recompose'
import { Trans, withI18n } from '@lingui/react'

import withStyles from 'material-ui/styles/withStyles'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'

import Section from 'components/Section'

type Props = {
  classes: Object,
  i18n: Object,
}

const HeroSection = ({ classes, i18n }: Props) => (
  <Section className={classes.root} anchor={'hero'}>
    <Grid className={classes.container} container spacing={0}>
      <Grid className={classes.content} item>
        <Typography className={classes.title} variant={'display2'}>
          <Trans id='hero.title' />
        </Typography>
        <Typography className={classes.subtitle} variant={'body1'}>
          <Trans id='hero.subtitle' />
        </Typography>
        <Button
          className={classes.button}
          component={Link}
          to={i18n._('hero.button_url')}
          color={'primary'}
          variant={'raised'}
          size={'large'}
        >
          <Trans id='hero.button_text' />
        </Button>
      </Grid>
      <Grid className={classes.image} item>
        <img
          className={classes.img}
          src={require('./images/phone_cropped.svg')}
          alt={i18n._('hero.subtitle')}
        />
      </Grid>
    </Grid>
  </Section>
)

const styles = theme => ({
  root: {
    display: 'flex',
    height: '100vh',
    color: '#fff',
    background: 'linear-gradient(to bottom, #222936 0%, #686d72 100%)',
    paddingTop: theme.spacing.unit * 10,
    paddingBottom: theme.spacing.unit * 2,
    overflow: 'hidden',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    maxWidth: '1920px',
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    flex: '1',
  },
  title: {
    color: 'inherit',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    marginBottom: theme.spacing.unit * 2,
    width: '100%',
    maxWidth: '420px',
    textAlign: 'inherit',
  },
  subtitle: {
    color: 'inherit',
    textAlign: 'inherit',
    marginBottom: theme.spacing.unit * 3,
    width: '100%',
  },
  button: {
    backgroundColor: '#29ABE2',
    display: 'inline-block',
    color: 'inherit',
    '&:hover': {
      backgroundColor: '#1E93BC',
    },
  },
  image: {
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center',
  },
  img: {
    height: '100%',
    width: '100%',
    transition: 'all .3s ease-in-out',
  },

  [`${theme.breakpoints.down('sm')} and (min-height: 600px) and (orientation: portrait)`]: {
    title: {
      marginBottom: theme.spacing.unit * 4,
    },
    subtitle: {
      marginBottom: theme.spacing.unit * 6,
    },
    img: {
      position: 'relative',
      width: '90%',
      height: '90%',
      bottom: '10%',
    },
  },

  [`${theme.breakpoints.up('md')}, (max-width: 960px) and (orientation: landscape)`]: {
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      textAlign: 'left',
    },
    content: {
      alignItems: 'flex-start',
      flex: '2',
    },
    title: {
      maxWidth: '540px',
    },
    image: {
      flex: '1',
    },
    img: {
      position: 'absolute',
      right: '2%',
      width: '50%',
      height: '50%',
    },
  },

  [`${theme.breakpoints.up('md')} and (min-height: 600px)`]: {
    title: {
      maxWidth: '560px',
      marginBottom: theme.spacing.unit * 4,
    },
    subtitle: {
      marginBottom: theme.spacing.unit * 6,
    },
  },

  '@media (min-width: 1100px)': {
    img: {
      width: '55%',
      height: '66%',
      right: '2%',
    },
  },

  [theme.breakpoints.up('lg')]: {
    title: {
      maxWidth: '760px',
      marginBottom: theme.spacing.unit * 6,
    },
    subtitle: {
      marginBottom: theme.spacing.unit * 8,
    },
    img: {
      width: '55%',
      height: '75%',
    },
  },

  '@media (min-width: 1400px)': {
    img: {
      width: '66%',
      height: '80%',
      right: '-3%',
    },
  },

  [theme.breakpoints.up('xl')]: {
    img: {
      width: '80%',
      height: '80%',
      right: '-5%',
    },
  },

  // iPad pro
  [`@media only screen
    and (min-device-width: 1024px)
    and (max-device-width: 1366px)
    and (orientation: portrait)
    and (-webkit-min-device-pixel-ratio: 1.5)
  `]: {
    container: {
      alignItems: 'initial',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
    },
    content: {
      alignItems: 'center',
      flex: '2',
    },
    title: {
      maxWidth: '600px',
    },
    image: {
      flex: '1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    img: {
      position: 'relative',
      right: '0',
      height: '100%',
      width: '100%',
      bottom: '33%',
    },
  },
})

export default compose(
  withI18n(),
  withStyles(styles),
)(HeroSection)



// WEBPACK FOOTER //
// ./src/components/Hero/index.js